<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <h3 class="page-title">RGPD</h3>
      </div>
    </div>

    <d-card class="card-small user-activity mb-4">
      <!-- Activity Items -->
      <d-card-body class="p-0" style="text-align: center">
        <iframe
          src="https://drive.google.com/file/d/157irMbFq3KcRxi4-RxG__IIL9vLqLvaf/preview??usp=drivesdk"
          class="myFrame"
        ></iframe>
      </d-card-body>
    </d-card>
  </div>
</template>

<script>
import TimeUtils from '../../utils/TimeUtils';
import notificationsModel from '../../data/notifications/notifications';

export default {
  name: 'rgpd',
};
</script>

<style scoped>
.myFrame {
  width: 600px;
  height: 500px;
  border-width: 0px;
}

@media only screen and (max-width: 600px) {
  .myFrame {
    width: 100%;
    height: 500px;
    border-width: 0px;
  }
}
</style>
